import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError,MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { TAIInstruction } from '@core/interfaces/TAIInstruction';
import { TProjectItem } from '@core/interfaces/TProjectItem';

import { CommonService } from '@shared/services/common.service';
import { ProjectsService } from '@shared/services/projects.service';

@Component({
    selector: 'app-new-projects-instructions-modal',
    templateUrl: './new-projects-instructions-modal.component.html',
    styleUrls: ['./new-projects-instructions-modal.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton]
})
export class NewProjectsInstructionsModalComponent implements OnInit {
  isEditMode = false;
  public newInstructionForm = this.fb.nonNullable.group({
    slug: ['slug', [Validators.required]],
    value: ['value', [Validators.required]],
    status: ['status', [Validators.required]],
    order: [1, [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NewProjectsInstructionsModalComponent>,
    private _commonService: CommonService,
    private _projectsService: ProjectsService,
    @Inject(MAT_DIALOG_DATA) public data: { project: TProjectItem, instruction?: TAIInstruction }
  ) {}

  ngOnInit() {
    if (this.data.instruction) {
      this.newInstructionForm.setValue({
        slug: this.data.instruction.slug,
        value: this.data.instruction.value as string,
        status: this.data.instruction.status,
        order: this.data.instruction.order,
      });
      this.isEditMode = true;
    }
  }

  public get slug() {
    return this.newInstructionForm.get('slug')!;
  }

  public get value() {
    return this.newInstructionForm.get('value')!;
  }

  public get status() {
    return this.newInstructionForm.get('status')!;
  }

  public get order() {
    return this.newInstructionForm.get('order')!;
  }

  public save(): void {
    const newItem: TAIInstruction = {
      slug: this.newInstructionForm.get(`slug`)?.value ?? ``,
      status: this.newInstructionForm.get(`status`)?.value ?? ``,
      value: this.newInstructionForm.get(`value`)?.value ?? ``,
      order: Number(this.newInstructionForm.get(`order`)?.value) ?? 0,
    };
    if (this.data.instruction && this.isEditMode) {
      this._projectsService.editInstruction(this.data.project, newItem, () => {
        this.dialogRef.close(newItem);
        this._commonService.openSuccessSnackBar('Instruction edited successfully!');
      });
    } else {
      this._projectsService.addInstructionToProject(this.data.project, newItem, () => {
        this.dialogRef.close();
        this._commonService.openSuccessSnackBar('Instruction added successfully!');
      });
    }
  }
}
